import React from 'react'
import { sizes } from './const'

export interface MailIconProps {
    /**
     * This allows to pass a custom className to the component.
     *
     * Note: className overrides equivalent styles for size and fill
     *
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'
    /**
     * The color of the stroke
     *
     */
    stroke?: 'black' | 'white'
}

export const MailIcon = ({
    className = '',
    size = 'medium',
    stroke = 'black',
}: MailIconProps) => {
    return (
        <svg
            className={`js_MailIcon ${className} ${sizes[size]}`}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2417_371)">
                <path
                    d="M21 5.25L12 13.5L3 5.25"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.3594 12L3.23438 18.5344"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.7656 18.5344L13.6406 12"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2417_371">
                    <rect width="24" height="24" fill="none" />
                </clipPath>
            </defs>
        </svg>
    )
}
